<template>
    <main>

        <slot></slot>
        <aside>
            <img src="../assets/img/registration-image.jpg" height="1387" width="926"/>
        </aside>
    </main>
</template>

<script>
    export default {
        name: "security"
    }
</script>

<style scoped lang="scss">
    aside {
        display: none;
    }

    /deep/ .actions {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px;
        margin: 32px 0;
        > div {

            text-align: center;

            > a {
                color: var(--color-primary);
            }
        }
    }


    @include screen-m {
        main {
            display: flex;

            > div {
                width: 70%;
            }
        }
        aside {
            width: 30%;
            display: block;
            height: 100vh;
            position: relative;

            > img {
                position: fixed;
                object-fit: cover;
                height: 100vh;
                width: 30vw;
            }
        }
    }
</style>
